import CustomFormattedMessage from "app/pages/.shared/CustomFormattedMessage/CustomFormattedMessage";
import { useSelector, shallowEqual } from "react-redux";
import {
	getAvailablePaymentTerms,
	getPartnerDepositPercentage,
} from "app/reducers/partnerSelector";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

// Constantes pour les options d'affichage
export const DISPLAY_OPTIONS = {
	DEPOSIT_PERCENTAGE: "depositPercentage",
	PAYMENT_TERMS: "paymentTerms",
	CALL_PRICE: "callPrice",
};

export const DEFAULT_DISPLAY_OPTIONS = {
	[DISPLAY_OPTIONS.DEPOSIT_PERCENTAGE]: true,
	[DISPLAY_OPTIONS.PAYMENT_TERMS]: true,
	[DISPLAY_OPTIONS.CALL_PRICE]: true,
};

// Hook personnalisé pour générer les valeurs
const useFormattedValues = (data, displayOptions, intl) => {
	const finalOptions = { ...DEFAULT_DISPLAY_OPTIONS, ...displayOptions };

	const valueConfig = {
		[DISPLAY_OPTIONS.DEPOSIT_PERCENTAGE]: {
			condition: data.onlinePercentage,
			generate: () =>
				`<span class="custom-formatted-message__value">${intl.formatMessage(
					{ id: "payment.terms.description.payment.percentage" },
					{ percentage: data.onlinePercentage }
				)}</span>`,
		},
		[DISPLAY_OPTIONS.PAYMENT_TERMS]: {
			condition: data.availablePaymentTerms.length > 0,
			generate: () =>
				data.availablePaymentTerms
					.filter(term => term !== 1)
					.map((term, index) => {
						const linkLabel =
							index !== 0
								? intl.formatMessage({
										id: "payment.terms.description.link.label",
									})
								: "";
						return `${
							index !== 0 ? `${linkLabel} ` : ""
						}<span class="custom-formatted-message__value">${term}x</span>`;
					})
					.join(""),
		},
		[DISPLAY_OPTIONS.CALL_PRICE]: {
			condition: data.lowestPrice,
			generate: () => data.lowestPrice,
		},
	};

	return Object.entries(valueConfig).reduce((acc, [key, config]) => {
		acc[key] = finalOptions[key] && config.condition ? config.generate() : "";
		return acc;
	}, {});
};

const CustomFormattedMessageContainer = ownProps => {
	const intl = useIntl();
	const stateProps = useSelector(state => mapStateToProps(state, ownProps), shallowEqual);
	const props = { ...ownProps, ...stateProps };
	const {
		onlinePercentage,
		availablePaymentTerms = [],
		lowestPrice,
		displayOptions = {},
		...restProps
	} = props;

	const values = useFormattedValues(
		{ onlinePercentage, availablePaymentTerms, lowestPrice },
		displayOptions,
		intl
	);

	return <CustomFormattedMessage {...restProps} values={values} />;
};

CustomFormattedMessageContainer.propTypes = {
	onlinePercentage: PropTypes.number,
	lowestPrice: PropTypes.number,
	availablePaymentTerms: PropTypes.array,
	displayOptions: PropTypes.shape({
		[DISPLAY_OPTIONS.DEPOSIT_PERCENTAGE]: PropTypes.bool,
		[DISPLAY_OPTIONS.PAYMENT_TERMS]: PropTypes.bool,
		[DISPLAY_OPTIONS.CALL_PRICE]: PropTypes.bool,
	}),
};

const mapStateToProps = (state, ownProps) => {
	return {
		onlinePercentage: getPartnerDepositPercentage(state),
		availablePaymentTerms: getAvailablePaymentTerms(state),
		lowestPrice: ownProps?.lowestPrice || state?.merchandising?.current?.lowestPrice,
	};
};

export default CustomFormattedMessageContainer;
